import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router';
import './index.css';
import { registerAllModules } from './modules.generated';
import { AuthProvider } from './auth';
import { App } from './app/App';
import { installErrorReporting } from './errors';

registerAllModules();
installErrorReporting();
// A page left open across a release asks for chunks the new build no longer has (a module's
// own lazy imports too, like the PDF engine). Vite reports those as vite:preloadError; reload
// once to pick up the new build instead of showing a dead screen.
window.addEventListener('vite:preloadError', (e) => {
  e.preventDefault();
  const KEY = 'tv.chunk.reloaded';
  let already = false;
  try { already = sessionStorage.getItem(KEY) === '1'; if (!already) sessionStorage.setItem(KEY, '1'); } catch { /* fine */ }
  if (!already) location.reload();
});
// App shell + push service worker (generated per environment, see vite.config.ts).
if ('serviceWorker' in navigator) window.addEventListener('load', () => { navigator.serviceWorker.register('/sw.js', { scope: '/' }).catch(() => {}); });

const qc = new QueryClient({ defaultOptions: { queries: { staleTime: 30_000, retry: 1 } } });

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={qc}>
      <AuthProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </AuthProvider>
    </QueryClientProvider>
  </StrictMode>,
);
